<template>
  <div>
    <h1>Nova de Moeda</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("moedas", ["moeda"]),
  },
  methods: {
    ...mapActions("moedas", ["ActionNewMoeda"]),
    loadData(id) {
      this.$router.push({ name: "moedas_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewMoeda();
  },
};
</script>

<style></style>
